export default __webpack_public_path__ + "static/media/Läsårstider-hem-2022-2023.e6cbc379.pdf";